import { useContext, useState } from "react";
import { AppContext } from "../App";
import { callApi } from "../Helpers";
import { MdClose } from "react-icons/md";

export default function ReservationForm(props) {
  const appContext = useContext(AppContext);

  const [loading, setLoading] = useState(false);

  const [fullname, setFullname] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [checkIn, setCheckIn] = useState("");
  const [checkOut, setCheckOut] = useState("");
  const [adults, setAdults] = useState("1");
  const [children, setChildren] = useState("0");

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePhone = (phone) => {
    const phoneRegex = /^[\d+\-\s()]+$/;
    return phoneRegex.test(phone) && phone.replace(/\D/g, "").length >= 7;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate fields
    if (!fullname || !fullname.trim()) {
      appContext.tellError("Please enter your full name");
      return;
    }

    if (!phone || !validatePhone(phone)) {
      appContext.tellError("Please enter a valid phone number");
      return;
    }

    if (!email || !validateEmail(email)) {
      appContext.tellError("Please enter a valid email address");
      return;
    }

    if (!checkIn) {
      appContext.tellError("Please select a check-in date");
      return;
    }

    if (!checkOut) {
      appContext.tellError("Please select a check-out date");
      return;
    }

    if (new Date(checkIn) >= new Date(checkOut)) {
      appContext.tellError("Check-out date must be after check-in date");
      return;
    }

    if (!adults || parseInt(adults) < 1) {
      appContext.tellError("Please select at least 1 adult");
      return;
    }

    setLoading(true);

    await callApi("create-reservation", {
      fullname: fullname.trim(),
      phone: phone.trim(),
      email: email.trim(),
      checkIn,
      checkOut,
      adults: parseInt(adults),
      children: parseInt(children),
    }).then((response) => {
      if (response.status === 1) {
        appContext.tellMessage(
          "Reservation submitted successfully! Check your email for confirmation.",
        );
        resetForm();
        appContext.navBack();
      } else {
        appContext.tellError(
          response.msg || "Could not submit reservation. Please try again.",
        );
      }
    });

    setLoading(false);
  };

  const resetForm = () => {
    setFullname("");
    setPhone("");
    setEmail("");
    setCheckIn("");
    setCheckOut("");
    setAdults("1");
    setChildren("0");
  };

  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };

  return (
    <div
      style={{
        padding: "30px",
        paddingTop: "20px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "30px",
        }}
      >
        <h3
          style={{
            fontSize: "24px",
            fontWeight: "600",
            color: "#1e3c72",
            margin: 0,
          }}
        >
          Make a Reservation
        </h3>
      </div>

      <p
        style={{
          color: "#666",
          fontSize: "14px",
          marginBottom: "25px",
          lineHeight: "1.5",
        }}
      >
        Fill in the details below to make your reservation. Our team will
        contact you within 24 hours to confirm and discuss your itinerary.
      </p>

      <form onSubmit={handleSubmit}>
        <div className="row g-3">
          {/* Full Name */}
          <div className="col-12">
            <label
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: "600",
                color: "#333",
                fontSize: "14px",
              }}
            >
              Full Name *
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter your full name"
              value={fullname}
              onChange={(e) => setFullname(e.target.value)}
              style={{
                borderRadius: "6px",
                border: "1px solid #ddd",
                padding: "10px 12px",
                fontSize: "14px",
              }}
            />
          </div>

          {/* Phone */}
          <div className="col-md-6">
            <label
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: "600",
                color: "#333",
                fontSize: "14px",
              }}
            >
              Phone Number *
            </label>
            <input
              type="tel"
              className="form-control"
              placeholder="+255 XXX XXX XXX"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              style={{
                borderRadius: "6px",
                border: "1px solid #ddd",
                padding: "10px 12px",
                fontSize: "14px",
              }}
            />
          </div>

          {/* Email */}
          <div className="col-md-6">
            <label
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: "600",
                color: "#333",
                fontSize: "14px",
              }}
            >
              Email Address *
            </label>
            <input
              type="email"
              className="form-control"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{
                borderRadius: "6px",
                border: "1px solid #ddd",
                padding: "10px 12px",
                fontSize: "14px",
              }}
            />
          </div>

          {/* Check-In Date */}
          <div className="col-md-6">
            <label
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: "600",
                color: "#333",
                fontSize: "14px",
              }}
            >
              Check-In Date *
            </label>
            <input
              type="date"
              className="form-control"
              value={checkIn}
              onChange={(e) => setCheckIn(e.target.value)}
              min={getTodayDate()}
              style={{
                borderRadius: "6px",
                border: "1px solid #ddd",
                padding: "10px 12px",
                fontSize: "14px",
              }}
            />
          </div>

          {/* Check-Out Date */}
          <div className="col-md-6">
            <label
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: "600",
                color: "#333",
                fontSize: "14px",
              }}
            >
              Check-Out Date *
            </label>
            <input
              type="date"
              className="form-control"
              value={checkOut}
              onChange={(e) => setCheckOut(e.target.value)}
              min={checkIn || getTodayDate()}
              style={{
                borderRadius: "6px",
                border: "1px solid #ddd",
                padding: "10px 12px",
                fontSize: "14px",
              }}
            />
          </div>

          {/* Number of Adults */}
          <div className="col-md-6">
            <label
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: "600",
                color: "#333",
                fontSize: "14px",
              }}
            >
              Number of Adults *
            </label>
            <input
              className="form-control"
              value={adults}
              onChange={(e) => setAdults(e.target.value)}
              style={{
                borderRadius: "6px",
                border: "1px solid #ddd",
                padding: "10px 12px",
                fontSize: "14px",
              }}
            />
             
          </div>

          {/* Number of Children */}
          <div className="col-md-6">
            <label
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: "600",
                color: "#333",
                fontSize: "14px",
              }}
            >
              Number of Children
            </label>
            <input
              className="form-control"
              value={children}
              onChange={(e) => setChildren(e.target.value)}
              style={{
                borderRadius: "6px",
                border: "1px solid #ddd",
                padding: "10px 12px",
                fontSize: "14px",
              }}
            />
          </div>

          {/* Submit Button */}
          <div className="col-12" style={{ marginTop: "20px" }}>
            <button
              type="submit"
              disabled={loading}
              className="btn btn-primary btn-padded"
              style={{
                width: "100%",
                padding: "12px",
                fontSize: "16px",
                fontWeight: "600",
                borderRadius: "6px",
                opacity: loading ? 0.7 : 1,
                cursor: loading ? "not-allowed" : "pointer",
              }}
            >
              {loading ? "Submitting..." : "Submit Reservation"}
            </button>
          </div>
        </div>
      </form>

      <p
        style={{
          color: "#999",
          fontSize: "12px",
          marginTop: "20px",
          textAlign: "center",
        }}
      >
        * indicates required fields
      </p>
    </div>
  );
}
